import { REHYDRATE } from 'redux-persist';

const defaults: State = {
  data: {
    sourceTypes: [],
    orderTypes: [],
    revenueTypes: [],
    sensorGrpTypes: [],
    activeCheckFilter: 'sourceType',
  },
};

export interface ActionType {
  type: string;
  payload: any;
}

export default (state: State = defaults, action: ActionType) => {
  switch (action.type) {
    case 'UPDATE_SOURCE_TYPES': {
      return { ...state, data: { ...action.payload } };
    }
    case REHYDRATE: {
      if (
        action.payload &&
        action.payload.storeTypesPersist &&
        action.payload.storeTypesPersist.data
      ) {
        return { ...state, ...action.payload.storeTypesPersist };
      }
      return { ...defaults };
    }
    default:
      return state;
  }
};
